const GetTranslation = {
  methods: {
    getTranslation(item, prop = 'title') {
      // pass array with several objects containing lang: '<lang>'
      const translation = item.find((x) => x.lang === this.lang)

      if (translation) {
        return translation[prop]
      }
      return ''
    },
  },
}

export default GetTranslation
